// extracted by mini-css-extract-plugin
export var borderRadius = "_6w-4";
export var large = "_6w-3";
export var logoContainer = "_6w-0";
export var nameLogo = "_6w-2";
export var small = "_6w-1";